import React, { useContext, useEffect, useState } from 'react';
import { Trans } from '@lingui/react';
import { createCalendarSubscription, editCalendarSubscription } from '../../../../Service/restapi/calDAVService';
import { LoadingAnimation } from '../../../../Service/ResourceAdapter';
import { Subscription } from './Subscription';
import { Checkbox, Stack, Text, Title } from '@mantine/core';

export const SubscriptionCalendar = () => {
  const [loading, setLoading] = useState(false);
  const [subscription, setSubscription] = useState();

  useEffect(() => {
    getCalendar();
  }, []);

  const editCalendar = async (patch) => {
    const _subscription = await editCalendarSubscription(subscription.id, patch);
    if (_subscription) {
      setSubscription(_subscription);
    }
  };

  function getCalendar() {
    setLoading(true);
    createCalendarSubscription()
      .then((resp) => {
        if (resp.ok) {
          resp.json().then((calendarSubscription) => {
            setSubscription(calendarSubscription);
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  if (loading) {
    return <LoadingAnimation />;
  }

  return (
    <>
      <Stack>
        <Text>
          <Trans id="settings.calendar.subscription.description" />
        </Text>
        <Text>
          <Trans id="settings.calendar.subscription.manual.macos" />
        </Text>
        <Text>
          <Trans id="settings.calendar.subscription.manual.ios" />
        </Text>
      </Stack>
      <Title order={5} style={{ marginTop: 20 }}>
        Deine Buchungen:
      </Title>
      {subscription && <Subscription calendarSubscriptionId={subscription.id} entityType="events" />}
      {subscription && <>
        <Checkbox
          mt="xs"
          checked={subscription.useCustomStateLabels}
          onChange={() => editCalendar({useCustomStateLabels: !subscription.useCustomStateLabels})}
          label="Eigenen Buchungsstatus verwenden"
        />
        <Checkbox
          mt="xs"
          checked={subscription.useEventDateDescription}
          onChange={() => editCalendar({useEventDateDescription: !subscription.useEventDateDescription})}
          label="Event-Tag-Beschreibung verwenden"
        />
      </>}
      <Title order={5} style={{ marginTop: 20 }}>
        Deine Vermittlungen im Dienstleister-Netzwerk:
      </Title>
      {subscription && (
        <>
          <Subscription calendarSubscriptionId={subscription.id} entityType="recommendations" />
          <Checkbox
            checked={subscription.showOnlySharedRecommendations}
            onChange={() =>
              editCalendar({ showOnlySharedRecommendations: !subscription.showOnlySharedRecommendations })
            }
            label="Nur Vermittlungen eintragen, deren Auftragsdaten geteilt wurden"
          />
        </>
      )}
    </>
  );
};
